export const ASSET_MODAL_RIGHT_PANEL_OPEN_TABS = ['info', 'comments', 'insights'] as const;

export type AssetModalRightPanelOpenTab = (typeof ASSET_MODAL_RIGHT_PANEL_OPEN_TABS)[number];

export type AssetModalRightPanelsTab = AssetModalRightPanelOpenTab | 'none';

export const isAssetModalRightPanelTabOpen = (tab: AssetModalRightPanelsTab): tab is AssetModalRightPanelOpenTab =>
  tab !== 'none';
